import { locales } from "@/lib/i18n/config";

/**
 * The same address in another language: only the locale segment changes, so
 * a language switch never also becomes a navigation (filters, pagination and
 * the record being viewed all survive).
 */
export function localizedPath(pathname: string, search: string, nextLocale: string): string {
  const path = pathname || "/";
  const localePattern = new RegExp(`^/(${locales.join("|")})(/|$)`);
  const nextPath = localePattern.test(path)
    ? path.replace(localePattern, `/${nextLocale}$2`)
    : `/${nextLocale}${path.startsWith("/") ? "" : "/"}${path}`;
  return `${nextPath}${search}`;
}
